import React from 'react';
import {
  FaHandshake,
  FaBullhorn,
  FaMapMarkedAlt,
  FaLightbulb,
  FaEnvelopeOpenText,
} from 'react-icons/fa';
import partnershipImage from "../../imgs/brand-deals-mobile.jpg";
import './Partnerships.css';

const partnershipSections = [
  {
    icon: <FaHandshake />,
    title: "Brand Partnerships",
    lead: "Long-term collaborations built for consistency and cultural impact. Brand Partnerships are designed for companies seeking ongoing visibility and deeper audience connection through talent-led storytelling.",
    items: [
      "Social media integrations (Instagram, TikTok, YouTube, Podcasts)",
      "Branded skits or recurring content segments",
      "Talent as brand ambassadors",
      "Product placement and organic mentions",
      "Co-branded merchandise and giveaways",
      "Live event activations and pop-ups",
    ],
    tagline: "monthly or multi-month partnerships.",
  },
  {
    icon: <FaBullhorn />,
    title: "Sponsorships",
    lead: "High-visibility placements tied to specific content, shows, or events. Sponsorships offer a flexible way to gain exposure through curated brand placements without a long-term commitment.",
    items: [
      "“Presented by” or “Sponsored by” placements",
      "Logo inclusion on digital assets and show marketing",
      "On-stage or on-air verbal mentions",
      "Sponsored podcast or video segments",
      "Email and SMS campaign mentions",
      "On-site brand presence at select events",
    ],
    tagline: "product launches, promotions, or market testing.",
  },
  {
    icon: <FaMapMarkedAlt />,
    title: "Tour Sponsorships",
    lead: "National reach through live comedy tours and sold-out venues. Tour Sponsorships provide brands with exposure across multiple cities through live performances and supporting digital content.",
    items: [
      "Tour title or presenting sponsorship",
      "Brand integration across multiple tour stops",
      "On-stage shoutouts per performance",
      "Venue signage and branded displays",
      "Co-branded merchandise or audience giveaways",
      "VIP experiences, meet-and-greets, and activations",
      "Localized social media promotion by city",
    ],
    tagline: "brands seeking regional or national visibility.",
  },
  {
    icon: <FaLightbulb />,
    title: "Our Approach",
    lead: "A framework built around authenticity, transparency, and measurable results.",
    items: [
      "Fully customized partnership packages",
      "Talent-first, audience-driven integrations",
      "Authentic storytelling over traditional ads",
      "Clear deliverables and performance reporting",
      "Scalable opportunities from local to national campaigns",
    ],
  },
];

const Partnerships = () => {
  return (
    <section className="partnerships-section">
      <div className="partnerships-container">
        <header className="partnerships-header">
          <span className="partnerships-eyebrow">
            Collaborate
          </span>
          <h1 className="partnerships-title">Brand Partnerships &amp; Sponsorships</h1>
        </header>

        <div className="partnerships-intro">
          <div className="partnerships-intro-media">
            <img
              src={partnershipImage}
              alt="Brand partnerships banner"
              className="partnerships-banner"
            />
          </div>
          <p className="partnerships-intro-text">
            We collaborate with brands to create authentic, high-impact integrations across
            live comedy, digital content, and national tours. Every partnership is customized
            to align with your goals while staying true to our audience and talent.
          </p>
        </div>

        <div className="partnerships-grid">
          {partnershipSections.map((section, i) => (
            <article className="partnership-card" key={section.title}>
              <div className="partnership-card-head">
                <span className="partnership-icon" aria-hidden="true">
                  {section.icon}
                </span>
                <span className="partnership-index" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <h2 className="partnership-title">{section.title}</h2>

              {section.lead && (
                <p className="partnership-lead">{section.lead}</p>
              )}

              <ul className="partnership-list">
                {section.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>

              {section.tagline && (
                <p className="partnership-tagline">
                  <span className="partnership-tagline-label">Ideal for</span>
                  {section.tagline}
                </p>
              )}
            </article>
          ))}
        </div>

        <div className="partnerships-cta-block">
          <span className="partnership-icon partnership-icon--large" aria-hidden="true">
            <FaEnvelopeOpenText />
          </span>
          <h2 className="partnership-title">Partner With Us</h2>
          <p className="partnerships-cta-copy">
            Interested in collaborating with our talent or sponsoring an upcoming project
            or tour? Submit an inquiry and our team will create a custom partnership
            proposal tailored to your brand.
          </p>
          <a href="mailto:info@lrmmanagement.com" className="email-button">
            <span className="email-button-label">Email Us</span>
            <span className="email-button-arrow" aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Partnerships;
